/**
 * VectorHub preference catalogue (`product: 'vh'`).
 *
 * Layout / grid-config keys are produced by app-kit adapters — they are not
 * listed here. Platform prefs (`themePref`, `localePref`, `densityPref`) live in
 * `@rammetec/app-kit/preferences`.
 */
import { definePreference } from '@rammetec/data-access/preferences';
/**
 * Tool names the user chose to auto-approve ("Sempre aplicar") in the assistant.
 * Product-owned list — app-kit only receives it via `autoApprovedTools`.
 */
export const assistantAutoApprovePref = definePreference({
    key: 'assistant:autoApprove',
    product: 'vh',
    scope: 'user',
    defaultValue: [],
    parse: (raw) => {
        if (!Array.isArray(raw))
            return null;
        if (!raw.every((item) => typeof item === 'string'))
            return null;
        return raw;
    },
    label: 'Ações automáticas do assistente',
});
//# sourceMappingURL=catalogue.js.map